import { useTheme } from '@mui/material/styles';
export { ThemeProvider, css, keyframes, styled } from '@mui/material/styles';
import { alpha } from '@mui/system';
import { _palette } from '../foundation/utils.js';

const useUtility = () => {
  const theme = useTheme();
  return {
    alpha: alpha,
    spacing: theme.spacing,
    breakpoints: theme.breakpoints,
    palette: _palette({
      theme
    }),
    isLight: theme.palette.mode === 'light'
  };
};

export { useUtility };
